import { type FC } from "react";
import { Field } from "react-final-form";
import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCountryAccessesSelectQuery } from "@/partner/entities/countryAccesses";

/**
 * Селект шаблона гео-доступа. Пустая опция = «действует шаблон по умолчанию»
 * (countryAccessId: null); если шаблонов нет вообще — она же означает
 * «доступно во всех странах».
 */
export const CountryAccessField: FC = () => {
  const { t } = useTranslation();
  const { data } = useCountryAccessesSelectQuery();
  const templates = data?.countryAccesses?.nodes ?? [];
  const defaultTemplate = templates.find((item) => item.isDefault);

  return (
    <Field name="countryAccessId">
      {({ input }) => (
        <TextField
          select
          fullWidth
          variant="outlined"
          label={t("videos.form.countryAccessLabel")}
          value={input.value || ""}
          onChange={(event) => input.onChange(event.target.value || null)}
        >
          <MenuItem value="">
            {defaultTemplate
              ? t("videos.form.countryAccessDefaultOption", {
                  title: defaultTemplate.title,
                })
              : t("videos.form.countryAccessDefaultOptionEmpty")}
          </MenuItem>
          {templates.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Field>
  );
};
